module.exports = __webpack_public_path__ + "img/Layout-Verse-desktop.cd9799ed.png";